import request from '../utils/request';

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data,
  });
}
export function loginStep2(data) {
  return request({
    url: '/auth/loginstep2',
    method: 'post',
    data,
  });
}

export function getInfo(token) {
  return request({
    url: '/auth/info',
    method: 'get',
    // params: { token },
  });
}

export function refresh() {
  return request({
    url: '/auth/refresh',
    method: 'get',
  });
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'get',
  });
}

export function getCsrfToken() {
  return request({
    url: '/getTime',
    method: 'get',
  });
}
